<template>
  <div class="page">
    <div class="top">
      <div class="title">当前可用积分</div>
      <div class="num-wrap">
        <van-icon
          v-if="bindFlag == '3'"
          class="icon-link m-white"
          name="info"
        />
        <div v-if="bindFlag == '3'" class="m-white t">已冻结</div>
        <div
          class="num"
          v-if="bindFlag == '1' || bindFlag == '3'"
          :class="{ grey: bindFlag == '3' }"
          v-text="pointStat.userPoint"
        ></div>
        <div class="o-info" v-if="bindFlag == '2' || bindFlag == '3'">
          <van-popover
            theme="dark"
            placement="bottom"
            v-model="bindInfoShow"
            trigger="click"
          >
            <div class="u-point-info">
              <div v-if="bindFlag == '1'">
                微信已绑定“图书馆微服务”，积分累计正常
              </div>
              <div v-if="bindFlag == '2'">
                微信未绑定“图书馆微服务”，尚未累计积分
              </div>
              <div v-if="bindFlag == '3'">
                微信已解绑“图书馆微服务”，积分累计停止
              </div>
            </div>
            <template #reference>
              <div class="info">
                <div class="status">
                  <div v-if="bindFlag == '1'">正常</div>
                  <div v-if="bindFlag == '2'">未启用</div>
                  <div v-if="bindFlag == '3'">已冻结</div>
                </div>
                <van-icon
                  v-if="bindFlag == '2'"
                  class="icon-link"
                  name="question"
                />
                <van-icon
                  v-if="bindFlag == '3'"
                  class="icon-link"
                  name="info"
                />
              </div>
            </template>
          </van-popover>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="btn" @click="handleRouter('/integral')">
          <img class="icon" src="../assets/images/icon-mingxi.png" />
          <div class="text">积分明细</div>
        </div>
        <div class="btn" @click="handleRouter('/integralReport')">
          <img class="icon" src="../assets/images/icon-baobiao.png" />
          <div class="text">积分报表</div>
        </div>
      </div>
    </div>
    <div class="rule-wrap">
      <div v-html="explainDetails" class="edit"></div>
      <table>
        <tr>
          <td class="header name">规则名称</td>
          <td class="header score">分值</td>
          <td class="header">说明</td>
        </tr>
        <tr v-for="(item, index) in ruleList" :key="index">
          <td class="name" v-text="item.ruleName"></td>
          <td class="score" v-text="item.pointValue"></td>
          <td v-text="item.ruleComments"></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import {
  getPoint,
  getPointRule,
  getDetails,
  userPointSignGet,
} from "@/api/integral";
import moment from "moment";
import { STATUS_CODE_OK } from "@/config";
export default {
  name: "IntegralRule",
  data() {
    return {
      bindInfoShow: false, // 绑定状态提示pop是否显示
      bindFlag: "1", // 公众号绑定状态
      ruleList: [],
      pointStat: {},
      explainDetails: "", //富文本
    };
  },
  created() {
    this.handleQuery();
    this.handlePoint();
    this.handleDetails();
    this.handleUserPointGet();
  },
  methods: {
    // 用户积分获取
    async handleUserPointGet() {
      const { data } = await userPointSignGet();
      if (data.code === STATUS_CODE_OK) {
        this.bindFlag = data.data.bindFlag;
      }
    },
    //获取用户积分
    async handlePoint() {
      const { data } = await getPoint({
        startTime: moment().format("YYYY-MM-DD"),
        endTime: moment().format("YYYY-MM-DD"),
      });
      if (data.code === STATUS_CODE_OK) {
        this.pointStat = data.data;
      }
    },

    //获取积分说明富文本
    async handleDetails() {
      const { data } = await getDetails();
      if (data.code === STATUS_CODE_OK) {
        this.explainDetails = data.data.explainDetails;
      }
    },

    handleRouter(path) {
      this.$router.replace(path);
    },
    async handleQuery() {
      const { data } = await getPointRule();
      if (data.code === STATUS_CODE_OK) {
        this.ruleList = data.data;
      }
    },
  },
};
</script>

<style lang="scss">
.u-point-info {
  font-size: 12px;
  padding: 6px 12px;
  width: 180px;
}
</style>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  .top {
    background-color: #3770d3;
    color: #fff;
    padding: 15px 0;
    .title {
      text-align: center;
      font-size: 16px;
    }
    .num-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 3px;
      .m-white {
        visibility: hidden;
        &.icon-link {
          margin: 0 1px 0 10px;
        }
        &.t {
          padding-right: 10px;
        }
      }
      .num {
        color: #fff;
        font-size: 18px;
        &.grey {
          color: #ccc;
        }
      }
      .o-info {
        display: flex;
        align-items: center;
        .info {
          display: flex;
          align-items: center;
          padding: 0 10px;
          cursor: pointer;
          .status {
            color: #ccc;
          }
          .icon-link {
            color: #ccc;
            font-size: 14px;
            margin-left: 2px;
          }
        }
      }
    }
    .btn-wrap {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        display: flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 20px;
        border: 1px solid #fff;
        margin: 0 20px;
        font-size: 12px;
        cursor: pointer;
        .icon {
          width: 15px;
          height: 15px;
          display: block;
          margin-right: 5px;
        }
      }
    }
  }
  .edit {
    padding-bottom: 10px;
  }
  .rule-wrap {
    background-color: #fff;
    padding: 10px;
    flex: 1;
    overflow-y: auto;
    table {
      tr {
        &:nth-of-type(odd) {
          background-color: #f1f1f3;
        }
        &:nth-of-type(even) {
          background-color: #fff;
        }
        td {
          font-size: 12px;
          padding: 10px;
          &.name {
            width: 120px;
          }
          &.score {
            width: 50px;
            padding: 10px 0;
            text-align: center;
          }
          &.header {
            color: #000;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
